<template>
<div class="chapter">
<div class="inner_page">
<a id="p2"></a>
<blockquote class="sink">
<p class="center "><em>To the one who opened doors for me</em><br/>
<em>and showed me the way—</em><br/>
<em>and also in memory of</em><br/>
<em>Almeida Garrett, master-traveller</em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?11f5e90b